import request from '@/axios'

export function getCustomerRedLight(data) {
  return request({
    url: `/inside/ai/customerAsset/getCustomerRedLight`,
    data
  })
}

// 客户跟进复盘详情
export function getBehavingDetail(data) {
  return request({
    url: '/inside/customerReview/getBehavingDetail',
    data
  })
}

// 会话详情页客户详情
export function getCustomerDetail(data) {
  return request({
    url: '/inside/customerReview/customer/detail/get',
    data
  })
}

// 获取模版
export function getTemplateList(data) {
  return request({
    url: '/inside/ai/asset/dashboard/form/list',
    data
  })
}

// 获取客户列表
export function getCustomerList(data) {
  return request({
    url: '/inside/ai/asset/dashboard/customer/list',
    data
  })
}

// 数据更新
export function updateList(data) {
  return request({
    url: '/inside/ai/asset/dashboard/update',
    data
  })
}
